import { useAuth } from "@/components/AuthCallback";
import { Film, Camera, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function WelcomePage() {
  const { login } = useAuth();

  return (
    <div className="min-h-screen bg-[#050505] relative overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{
          backgroundImage: "url('https://images.pexels.com/photos/7991579/pexels-photo-7991579.jpeg')",
          filter: "grayscale(30%)"
        }}
      />
      
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#050505] via-[#050505]/80 to-transparent" />
      
      {/* Noise Texture */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`
      }} />

      {/* Content */}
      <div className="relative z-10 min-h-screen flex flex-col">
        {/* Header */}
        <header className="p-6 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_motion-ai-studio-8/artifacts/3d6asbml_Asset%2010SHOTS.png" 
              alt="SHOTS-GL" 
              className="h-12 object-contain"
            />
            <div className="h-8 w-px bg-[#262626]" />
            <img 
              src="https://customer-assets.emergentagent.com/job_motion-ai-studio-8/artifacts/mhhci9ys_Asset%201Mlogo%20en%20blanco.png" 
              alt="Grupo Locoff" 
              className="h-10 object-contain opacity-60"
            />
          </div>
        </header>

        {/* Main Content */}
        <main className="flex-1 flex items-center justify-center px-6">
          <div className="max-w-2xl text-center">
            {/* Logo Grande */}
            <div className="mb-8">
              <img 
                src="https://customer-assets.emergentagent.com/job_motion-ai-studio-8/artifacts/3d6asbml_Asset%2010SHOTS.png" 
                alt="SHOTS-GL" 
                className="h-24 sm:h-32 object-contain mx-auto"
              />
            </div>

            {/* Description */}
            <p className="text-lg text-[#A3A3A3] mb-8 leading-relaxed max-w-lg mx-auto">
              Director de fotografía inteligente para Higgsfield AI. 
              Genera instrucciones cinematográficas precisas para dar vida a tus imágenes.
            </p>

            {/* Features */}
            <div className="grid grid-cols-3 gap-4 mb-10 max-w-md mx-auto">
              <div className="p-4 rounded-lg bg-[#0A0A0A]/80 border border-[#262626]">
                <Camera className="w-5 h-5 text-[#BEF264] mx-auto mb-2" />
                <p className="font-mono text-[10px] text-[#737373] uppercase">40+ Movimientos</p>
              </div>
              <div className="p-4 rounded-lg bg-[#0A0A0A]/80 border border-[#262626]">
                <Film className="w-5 h-5 text-[#F97316] mx-auto mb-2" />
                <p className="font-mono text-[10px] text-[#737373] uppercase">5 Modos</p>
              </div>
              <div className="p-4 rounded-lg bg-[#0A0A0A]/80 border border-[#262626]">
                <Sparkles className="w-5 h-5 text-[#3B82F6] mx-auto mb-2" />
                <p className="font-mono text-[10px] text-[#737373] uppercase">3 IAs</p>
              </div>
            </div>

            {/* Login Button */}
            <Button
              onClick={login}
              size="lg"
              className="bg-white hover:bg-white/90 text-black font-mono text-sm tracking-wider px-8 py-6 rounded-lg gap-3 shadow-lg shadow-white/10"
              data-testid="welcome-login-btn"
            >
              <svg className="w-5 h-5" viewBox="0 0 24 24">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
              </svg>
              CONTINUAR CON GOOGLE
            </Button>

            <p className="font-mono text-[10px] text-[#404040] mt-6">
              Parte del ecosistema Grupo Locoff
            </p>
          </div>
        </main>

        {/* Footer */}
        <footer className="p-6 text-center">
          <p className="font-mono text-[10px] text-[#404040] tracking-wider">
            BRAIN · CORE · SHOTS-GL
          </p>
        </footer>
      </div>
    </div>
  );
}
